// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mapbox GL overrides */
.mapboxgl-canvas {
  border-radius: 1rem;
}

.mapboxgl-ctrl-logo,
.mapboxgl-ctrl-attrib {
  display: none !important;
}

.mapboxgl-popup {
  max-width: 300px;
}

.mapboxgl-popup-content {
  padding: 0;
  border-radius: 0.5rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

/* Country labels styling */
.mapboxgl-canvas-container.click-to-zoom {
  cursor: pointer;
}

.mapboxgl-canvas-container.click-to-zoom-touch {
  touch-action: pinch-zoom;
}

/* Smooth transitions */
.mapboxgl-canvas {
  transition: opacity 0.3s ease;
}

/* ── zoom buttons ─────────────────────────────────────────────────────────
   Mapbox's own are white squares with a hard shadow, which sit oddly on the
   dark console. Match the panel instead, in both themes. */
.mapboxgl-ctrl-group {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
  overflow: hidden;
}
.mapboxgl-ctrl-group button + button { border-top: 1px solid #e2e8f0; }
.mapboxgl-ctrl-group button { width: 30px; height: 30px; }
.mapboxgl-ctrl-group button:hover { background: #f1f5f9; }

.dark .mapboxgl-ctrl-group {
  background: rgba(15, 23, 42, 0.9);
  border-color: #334155;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.45);
}
.dark .mapboxgl-ctrl-group button + button { border-top-color: #334155; }
.dark .mapboxgl-ctrl-group button:hover { background: rgba(148, 163, 184, 0.14); }
.dark .mapboxgl-ctrl-icon { filter: invert(1) brightness(1.6); }

/* the "use ctrl + scroll" hint that keeps the page scrolling past the map */
.mapboxgl-scroll-zoom-blocker,
.mapboxgl-touch-pan-blocker {
  border-radius: 1rem;
  font-size: 13px;
}

/* Clicking the map focused the canvas and drew a browser outline right
   across the panel's rounded edge. */
.mapboxgl-canvas:focus,
.mapboxgl-canvas-container:focus,
.mapboxgl-map:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/BestMap.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;AAC/B;;AAEA;;2DAE2D;AAC3D;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA,uCAAuC,6BAA6B,EAAE;AACtE,8BAA8B,WAAW,EAAE,YAAY,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;;AAEzD;EACE,iCAAiC;EACjC,qBAAqB;EACrB,0CAA0C;AAC5C;AACA,6CAA6C,yBAAyB,EAAE;AACxE,0CAA0C,qCAAqC,EAAE;AACjF,4BAA4B,iCAAiC,EAAE;;AAE/D,4EAA4E;AAC5E;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;qCACqC;AACrC;;;EAGE,aAAa;AACf","sourcesContent":["/* Mapbox GL overrides */\n.mapboxgl-canvas {\n  border-radius: 1rem;\n}\n\n.mapboxgl-ctrl-logo,\n.mapboxgl-ctrl-attrib {\n  display: none !important;\n}\n\n.mapboxgl-popup {\n  max-width: 300px;\n}\n\n.mapboxgl-popup-content {\n  padding: 0;\n  border-radius: 0.5rem;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n}\n\n/* Country labels styling */\n.mapboxgl-canvas-container.click-to-zoom {\n  cursor: pointer;\n}\n\n.mapboxgl-canvas-container.click-to-zoom-touch {\n  touch-action: pinch-zoom;\n}\n\n/* Smooth transitions */\n.mapboxgl-canvas {\n  transition: opacity 0.3s ease;\n}\n\n/* ── zoom buttons ─────────────────────────────────────────────────────────\n   Mapbox's own are white squares with a hard shadow, which sit oddly on the\n   dark console. Match the panel instead, in both themes. */\n.mapboxgl-ctrl-group {\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);\n  overflow: hidden;\n}\n.mapboxgl-ctrl-group button + button { border-top: 1px solid #e2e8f0; }\n.mapboxgl-ctrl-group button { width: 30px; height: 30px; }\n.mapboxgl-ctrl-group button:hover { background: #f1f5f9; }\n\n.dark .mapboxgl-ctrl-group {\n  background: rgba(15, 23, 42, 0.9);\n  border-color: #334155;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.45);\n}\n.dark .mapboxgl-ctrl-group button + button { border-top-color: #334155; }\n.dark .mapboxgl-ctrl-group button:hover { background: rgba(148, 163, 184, 0.14); }\n.dark .mapboxgl-ctrl-icon { filter: invert(1) brightness(1.6); }\n\n/* the \"use ctrl + scroll\" hint that keeps the page scrolling past the map */\n.mapboxgl-scroll-zoom-blocker,\n.mapboxgl-touch-pan-blocker {\n  border-radius: 1rem;\n  font-size: 13px;\n}\n\n/* Clicking the map focused the canvas and drew a browser outline right\n   across the panel's rounded edge. */\n.mapboxgl-canvas:focus,\n.mapboxgl-canvas-container:focus,\n.mapboxgl-map:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
